import { render, staticRenderFns } from "./dashBoard.vue?vue&type=template&id=c9ab2054&scoped=true"
import script from "./dashBoard.vue?vue&type=script&lang=js"
export * from "./dashBoard.vue?vue&type=script&lang=js"
import style0 from "./dashBoard.vue?vue&type=style&index=0&id=c9ab2054&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9ab2054",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c9ab2054')) {
      api.createRecord('c9ab2054', component.options)
    } else {
      api.reload('c9ab2054', component.options)
    }
    module.hot.accept("./dashBoard.vue?vue&type=template&id=c9ab2054&scoped=true", function () {
      api.rerender('c9ab2054', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/myTask/dashBoard.vue"
export default component.exports